module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/740b0ad766f4e23a67c948af0c4eff22.png";